import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Stream illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-stream',

    shadow: true,
})
export class EsIllustrationStream {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 731 844.8"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <path
                    fill="#fff"
                    d="M292.1 44.9 292.1 484.7 652.5 674.1 727.8 632.1 727.8 212.8 364.2 3.3 292.1 44.9z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M654.3 254.1 727.8 212.8 727.8 632.1 654 674.1 654.3 254.1z"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="m582.8 296.5-.3 343.9 39.3-22.7c.4-.4.7-.8.7-1.4V273.4c0-.6-.3-1.1-.8-1.3L326.4 101.5c-.5-.3-1.1-.3-1.5 0l-61.7 35.6 297.6 171.8 22.2-12.4Z"
                    opacity=".3"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="M622.3 272.8 582.8 296.5 582.5 640.5 621.7 617.9 622.3 272.8z"
                    opacity=".3"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M292.1 44.9 292.1 44.9 292.1 44.9 292.1 44.9z"
                />
                <path
                    fill="#1a4e85"
                    d="M324 103v127.8l3.1 1.8V105.7l292.3 168.8v339.4l-36.8-21.3v3.6l37.6 21.7c.5.3 1.1.3 1.5 0s.8-.8.8-1.3V273.5c0-.3 0-.5-.2-.8s-.3-.4-.6-.6L326.3 101.7c-.5-.3-1.1-.3-1.5 0s-.8.8-.8 1.3Z"
                />
                <path
                    fill="#1a4e85"
                    d="M289.1 45v165.6l6.2 3.6V46.8l69-39.9 360.5 207.7-.4 416-70 40.4-71.9-41.5v7.1l70.3 40.6c1 .6 2.1.6 3.1 0L729 635c1-.5 1.5-1.6 1.5-2.7l.4-419.6c0-.6-.1-1.1-.4-1.5s-.7-.9-1.1-1.1L365.8.7c-1-.5-2.1-.5-3.1 0l-72.1 41.6c-1 .6-1.5 1.6-1.5 2.7Z"
                />
                <rect height="7.1" x="438.6" y="546.5" fill="#fff" />
                <path
                    fill="#1a4e85"
                    d="M652.5 254.4v398.3h3.1V255.3l58.7-32.9c-.7-.8-1.3-1.6-1.9-2.4l-59 33.1c-.2.1-.4.3-.6.6-.1.2-.2.5-.2.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="m546.4 190.5 107.7 62.2 58.3-32.7c.6.8 1.3 1.6 1.9 2.4l-59.5 33.3c-.5.3-1.1.3-1.5 0L545 193.2c.5-.9.9-1.8 1.4-2.8ZM435.4 129.9l1.5-2.7-126.6-73.1c-.5.9-1 1.8-1.6 2.7L435.4 130Z"
                />
                <path
                    fill="#fff"
                    d="M147.1 128.7 219.2 87 582.8 296.5 583.2 717.4 510 759.1 144.1 546.5 147.1 128.7z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M509.8 339.5 582.8 296.5 583.2 713.8 510 759.1 509.8 339.5z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M147.1 128.7 147.1 128.7 147.1 128.7 147.1 128.7z"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="M476.8 701.4c.4-.3.7-.8.7-1.3v-343c0-.6-.3-1.1-.8-1.3L181.4 185.2c-.5-.3-1.1-.3-1.5 0l-39.6 22.9 7 29.5 268.5 155 23.1-12.9-.3 337.6 5.5 3.1 33-19Z"
                    opacity=".3"
                />
                <path
                    fill="#fff"
                    d="M438.4 676.8 438.4 677.4 438.4 676.8 438.4 676.8z"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="M477.3 356.5 437.2 379.7 438.4 723.4 476.8 701.4 477.3 356.5z"
                    opacity=".3"
                />
                <path
                    fill="#1a4e85"
                    d="M475.2 701.6c.5.3 1.1.3 1.5 0s.8-.8.8-1.3v-343c0-.3 0-.5-.2-.8s-.3-.4-.6-.6L181.3 185.4c-.5-.3-1.1-.3-1.5 0s-.8.8-.8 1.3v126.7l3.1 1.8V189.4l292.3 168.8v339.4l-36-20.8v3.6l36.7 21.2Z"
                />
                <path
                    fill="#1a4e85"
                    d="M585.6 295c-.3-.5-.7-.9-1.1-1.1L220.8 84.4c-1-.5-2.1-.5-3.1 0L145.6 126c-1 .6-1.5 1.6-1.5 2.7v164.6l3 1.7 3.2 1.8V130.5l69-39.8 360.4 207.7h.1l-.4 416.1-70 40.4-71-41v7.1l69.5 40.1c1 .6 2.1.6 3.1 0l73.1-42.2c1-.5 1.5-1.6 1.5-2.7l.4-419.6c0-.6-.1-1.1-.4-1.5Z"
                />
                <rect height="3.6" x="438.4" y="713.8" fill="#fff" />
                <rect height="3.6" x="148.7" y="294.1" fill="#fff" />
                <path
                    fill="#1a4e85"
                    d="m509.3 337.8 58.9-33c-.3-.4-.6-.7-.9-1.1l-59 33.1c-.1 0-.2.1-.3.2l1.3.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="m508 337-.3.3c-.1.2-.2.5-.2.8v398.3h3.1V339l58.7-32.9c-.4-.5-.7-.9-1.1-1.4l-58.9 33-1.3-.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="m509.3 337.8 58.9-33c-.3-.4-.6-.7-.9-1.1L509 336.4l-107.7-62.2c-.2.3-.3.7-.5 1l108.4 62.6Z"
                />
                <path
                    fill="#1a4e85"
                    d="m400.9 275.2-.9 1.8 108.3 62.5c.5.3 1 .3 1.5 0l59.5-33.3c-.4-.5-.7-.9-1.1-1.4l-58.9 33-108.4-62.6ZM291.4 211.9c.2-.3.4-.7.5-1l-126.6-73.1c-.2.3-.4.6-.6 1l126.7 73.1ZM163.7 140.5l126.7 73.2c.3-.6.6-1.2.9-1.7l-126.7-73.1c-.3.6-.7 1.1-1 1.7Z"
                />
                <path
                    fill="#fff"
                    d="M3.2 211.9 74.8 171.1 438.7 379.7 438.6 798.7 365 841.7 3.2 633.4 3.2 211.9z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M438.7 379.7 438.6 798.7 365 841.7 365.2 421 438.7 379.7z"
                />
                <path
                    fill="#1a4e85"
                    d="M333.1 439.7c.1.2.2.5.2.8v343c0 .6-.3 1.1-.8 1.3s-1.1.3-1.5 0L35.6 614.3c-.5-.3-.8-.8-.8-1.3V269.9c0-.6.3-1.1.8-1.3s1.1-.3 1.5 0l295.4 170.5c.2.1.4.3.6.6Zm-2.9 341.1V441.4L38 272.6V612l292.3 168.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="M441.5 378.2c.3.5.4 1 .4 1.5l-.4 419.6c0 1.1-.6 2.1-1.5 2.7l-73.1 42.2c-1 .6-2.1.6-3.1 0L1.5 635.1c-1-.5-1.5-1.6-1.5-2.7V211.9c0-1.1.6-2.1 1.5-2.7l72.1-41.6c1-.5 2.1-.6 3.1 0l363.6 209.5c.5.3.9.7 1.1 1.1Zm-6.2 419.4.4-416L75.2 173.8l-69 39.9v417L365.3 838l70-40.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="M363.9 420.2 365.2 421 363.9 420.2 363.9 420.2z"
                />
                <path
                    fill="#1a4e85"
                    d="m423.2 386.9-59 33.1c-.1 0-.2.1-.3.2l1.3.8 58.9-33c-.3-.4-.6-.7-.9-1.1Z"
                />
                <path
                    fill="#1a4e85"
                    d="m363.9 420.2-.3.3c-.1.2-.2.5-.2.8v398.3h3.1V422.2l58.7-32.9c-.4-.5-.7-.9-1.1-1.4l-58.9 33-1.3-.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="M365.2 421 424.1 388 424.1 388 365.2 421z"
                />
                <path
                    fill="#1a4e85"
                    d="M256.8 358.4 365.2 421 256.8 358.4 256.8 358.4z"
                />
                <path
                    fill="#1a4e85"
                    d="m423.2 386.9-58.3 32.7-107.7-62.2c-.2.3-.3.7-.5 1L365.1 421l58.9-33c-.3-.4-.6-.7-.9-1.1Z"
                />
                <path
                    fill="#1a4e85"
                    d="m256.8 358.4-.9 1.8 108.3 62.5c.5.3 1 .3 1.5 0l59.5-33.3c-.4-.5-.7-.9-1.1-1.4l-58.9 33-108.4-62.6Z"
                />
                <path
                    fill="#1a4e85"
                    d="M365.2 421 424.1 388 424.1 388 365.2 421z"
                />
                <path
                    fill="#1a4e85"
                    d="M21.2 221.1c-.2.3-.4.6-.6 1l126.5 73v-1.3L21.2 221.1Z"
                />
                <path
                    fill="#1a4e85"
                    d="M147.1 295.1 20.6 222c-.3.6-.7 1.1-1 1.7l126.7 73.2c.3-.6.6-1.2.9-1.7h-.1Z"
                />
                <rect height=".2" x="147.2" y="295" fill="#1a4e85" />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 731 844.8"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <path
                    fill="#ced4db"
                    d="M292.1 44.9 292.1 484.7 652.5 674.1 727.8 632.1 727.8 212.8 364.2 3.3 292.1 44.9z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M654.3 254.1 727.8 212.8 727.8 632.1 654 674.1 654.3 254.1z"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="m582.8 296.5-.3 343.9 39.3-22.7c.4-.4.7-.8.7-1.4V273.4c0-.6-.3-1.1-.8-1.3L326.4 101.5c-.5-.3-1.1-.3-1.5 0l-61.7 35.6 297.6 171.8 22.2-12.4Z"
                    opacity=".3"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="M622.3 272.8 582.8 296.5 582.5 640.5 621.7 617.9 622.3 272.8z"
                    opacity=".6"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M292.1 44.9 292.1 44.9 292.1 44.9 292.1 44.9z"
                />
                <path
                    fill="#09264a"
                    d="M324 103v127.8l3.1 1.8V105.7l292.3 168.8v339.4l-36.8-21.3v3.6l37.6 21.7c.5.3 1.1.3 1.5 0s.8-.8.8-1.3V273.5c0-.3 0-.5-.2-.8s-.3-.4-.6-.6L326.3 101.7c-.5-.3-1.1-.3-1.5 0s-.8.8-.8 1.3Z"
                />
                <path
                    fill="#fff"
                    d="M289.1 45v165.6l6.2 3.6V46.8l69-39.9 360.5 207.7-.4 416-70 40.4-71.9-41.5v7.1l70.3 40.6c1 .6 2.1.6 3.1 0L729 635c1-.5 1.5-1.6 1.5-2.7l.4-419.6c0-.6-.1-1.1-.4-1.5s-.7-.9-1.1-1.1L365.8.7c-1-.5-2.1-.5-3.1 0l-72.1 41.6c-1 .6-1.5 1.6-1.5 2.7Z"
                />
                <rect height="7.1" x="438.6" y="546.5" fill="#fff" />
                <path
                    fill="#09264a"
                    d="M652.5 254.4v398.3h3.1V255.3l58.7-32.9c-.7-.8-1.3-1.6-1.9-2.4l-59 33.1c-.2.1-.4.3-.6.6-.1.2-.2.5-.2.8Z"
                />
                <path
                    fill="#09264a"
                    d="m546.4 190.5 107.7 62.2 58.3-32.7c.6.8 1.3 1.6 1.9 2.4l-59.5 33.3c-.5.3-1.1.3-1.5 0L545 193.2c.5-.9.9-1.8 1.4-2.8ZM435.4 129.9l1.5-2.7-126.6-73.1c-.5.9-1 1.8-1.6 2.7L435.4 130Z"
                />
                <path
                    fill="#ced4db"
                    d="M147.1 128.7 219.2 87 582.8 296.5 583.2 717.4 510 759.1 144.1 546.5 147.1 128.7z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M509.8 339.5 582.8 296.5 583.2 713.8 510 759.1 509.8 339.5z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M147.1 128.7 147.1 128.7 147.1 128.7 147.1 128.7z"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="M476.8 701.4c.4-.3.7-.8.7-1.3v-343c0-.6-.3-1.1-.8-1.3L181.4 185.2c-.5-.3-1.1-.3-1.5 0l-39.6 22.9 7 29.5 268.5 155 23.1-12.9-.3 337.6 5.5 3.1 33-19Z"
                    opacity=".3"
                />
                <path
                    fill="#fff"
                    d="M438.4 676.8 438.4 677.4 438.4 676.8 438.4 676.8z"
                />
                <path
                    fill="#5ab552"
                    fill-rule="evenodd"
                    d="M477.3 356.5 437.2 379.7 438.4 723.4 476.8 701.4 477.3 356.5z"
                    opacity=".6"
                />
                <path
                    fill="#09264a"
                    d="M475.2 701.6c.5.3 1.1.3 1.5 0s.8-.8.8-1.3v-343c0-.3 0-.5-.2-.8s-.3-.4-.6-.6L181.3 185.4c-.5-.3-1.1-.3-1.5 0s-.8.8-.8 1.3v126.7l3.1 1.8V189.4l292.3 168.8v339.4l-36-20.8v3.6l36.7 21.2Z"
                />
                <path
                    fill="#fff"
                    d="M585.6 295c-.3-.5-.7-.9-1.1-1.1L220.8 84.4c-1-.5-2.1-.5-3.1 0L145.6 126c-1 .6-1.5 1.6-1.5 2.7v164.6l3 1.7 3.2 1.8V130.5l69-39.8 360.4 207.7h.1l-.4 416.1-70 40.4-71-41v7.1l69.5 40.1c1 .6 2.1.6 3.1 0l73.1-42.2c1-.5 1.5-1.6 1.5-2.7l.4-419.6c0-.6-.1-1.1-.4-1.5Z"
                />
                <rect height="3.6" x="438.4" y="713.8" fill="#fff" />
                <rect height="3.6" x="148.7" y="294.1" fill="#fff" />
                <path
                    fill="#1a4e85"
                    d="m509.3 337.8 58.9-33c-.3-.4-.6-.7-.9-1.1l-59 33.1c-.1 0-.2.1-.3.2l1.3.8Z"
                />
                <path
                    fill="#09264a"
                    d="m508 337-.3.3c-.1.2-.2.5-.2.8v398.3h3.1V339l58.7-32.9c-.4-.5-.7-.9-1.1-1.4l-58.9 33-1.3-.8Z"
                />
                <path
                    fill="#09264a"
                    d="m509.3 337.8 58.9-33c-.3-.4-.6-.7-.9-1.1L509 336.4l-107.7-62.2c-.2.3-.3.7-.5 1l108.4 62.6Z"
                />
                <path
                    fill="#09264a"
                    d="m400.9 275.2-.9 1.8 108.3 62.5c.5.3 1 .3 1.5 0l59.5-33.3c-.4-.5-.7-.9-1.1-1.4l-58.9 33-108.4-62.6ZM291.4 211.9c.2-.3.4-.7.5-1l-126.6-73.1c-.2.3-.4.6-.6 1l126.7 73.1ZM163.7 140.5l126.7 73.2c.3-.6.6-1.2.9-1.7l-126.7-73.1c-.3.6-.7 1.1-1 1.7Z"
                />
                <path
                    fill="#ced4db"
                    d="M3.2 211.9 74.8 171.1 438.7 379.7 438.6 798.7 365 841.7 3.2 633.4 3.2 211.9z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M438.7 379.7 438.6 798.7 365 841.7 365.2 421 438.7 379.7z"
                />
                <path
                    fill="#09264a"
                    d="M333.1 439.7c.1.2.2.5.2.8v343c0 .6-.3 1.1-.8 1.3s-1.1.3-1.5 0L35.6 614.3c-.5-.3-.8-.8-.8-1.3V269.9c0-.6.3-1.1.8-1.3s1.1-.3 1.5 0l295.4 170.5c.2.1.4.3.6.6Zm-2.9 341.1V441.4L38 272.6V612l292.3 168.8Z"
                />
                <path
                    fill="#fff"
                    d="M441.5 378.2c.3.5.4 1 .4 1.5l-.4 419.6c0 1.1-.6 2.1-1.5 2.7l-73.1 42.2c-1 .6-2.1.6-3.1 0L1.5 635.1c-1-.5-1.5-1.6-1.5-2.7V211.9c0-1.1.6-2.1 1.5-2.7l72.1-41.6c1-.5 2.1-.6 3.1 0l363.6 209.5c.5.3.9.7 1.1 1.1Zm-6.2 419.4.4-416L75.2 173.8l-69 39.9v417L365.3 838l70-40.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="M363.9 420.2 365.2 421 363.9 420.2 363.9 420.2z"
                />
                <path
                    fill="#1a4e85"
                    d="m423.2 386.9-59 33.1c-.1 0-.2.1-.3.2l1.3.8 58.9-33c-.3-.4-.6-.7-.9-1.1Z"
                />
                <path
                    fill="#09264a"
                    d="m363.9 420.2-.3.3c-.1.2-.2.5-.2.8v398.3h3.1V422.2l58.7-32.9c-.4-.5-.7-.9-1.1-1.4l-58.9 33-1.3-.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="M365.2 421 424.1 388 424.1 388 365.2 421z"
                />
                <path
                    fill="#1a4e85"
                    d="M256.8 358.4 365.2 421 256.8 358.4 256.8 358.4z"
                />
                <path
                    fill="#09264a"
                    d="m423.2 386.9-58.3 32.7-107.7-62.2c-.2.3-.3.7-.5 1L365.1 421l58.9-33c-.3-.4-.6-.7-.9-1.1Z"
                />
                <path
                    fill="#09264a"
                    d="m256.8 358.4-.9 1.8 108.3 62.5c.5.3 1 .3 1.5 0l59.5-33.3c-.4-.5-.7-.9-1.1-1.4l-58.9 33-108.4-62.6Z"
                />
                <path
                    fill="#09264a"
                    d="M365.2 421 424.1 388 424.1 388 365.2 421z"
                />
                <path
                    fill="#09264a"
                    d="M21.2 221.1c-.2.3-.4.6-.6 1l126.5 73v-1.3L21.2 221.1Z"
                />
                <path
                    fill="#09264a"
                    d="M147.1 295.1 20.6 222c-.3.6-.7 1.1-1 1.7l126.7 73.2c.3-.6.6-1.2.9-1.7h-.1Z"
                />
                <rect height=".2" x="147.2" y="295" fill="#1a4e85" />
            </svg>
        );
    }
}
